import { gql } from '@apollo/client';

export const FILES_QUERY = gql`
  query FilesQuery {
    files {
      id
      name
      s3Key
      records
      numUniqueRecords
      numMatchedRecords
      matchRate
      totalProcessingTime
      createdAt
      status
      crawledAt
      hasBeenProfiled
      errorMessage
      errorStage
      kind
      numSkippedRecords
      sourceKey
      scoreCounts
      dataSource
    }
  }
`;

// ATAD-146: the files in one Alliant data source's shared folder (CMDA model
// files when `source` is omitted), newest first, each with this user's newest
// import of it (any status; null when they haven't imported it). Role-gated
// on the server (model-files-user or admin).
export const MODEL_FILE_SOURCES = gql`
  query ModelFileSources($source: DataSource) {
    modelFileSources(source: $source) {
      key
      name
      size
      lastModified
      changedSinceImport
      latestImport {
        id
        name
        kind
        status
        createdAt
        crawledAt
        errorMessage
        errorStage
        numUniqueRecords
        numSkippedRecords
        numMatchedRecords
      }
    }
  }
`;
